import { localhostType, psychologistsSubDomains, usersSubDomains } from "screens/App/routes";

// TODO: Need better solution for this
const API_URL = process.env.API_URL;
const hostname = window.location.hostname?.split(".")?.[0];

export default {
	uriHome(id = "") {
		if (
			// @ts-ignore
			(hostname === "localhost" && localhostType === "psychologists") ||
			psychologistsSubDomains.includes(hostname)
		) {
			return `${API_URL}/psychologists/home/${id}`;
			// @ts-ignore
		} else if ((hostname === "localhost" && localhostType === "users") || usersSubDomains.includes(hostname)) {
			return `${API_URL}/users/home`;
		}
	},

	uriLogin() {
		return `${API_URL}/auth/login`;
	},

	uriUsersConfirmAccount(id = "") {
		return `${API_URL}/users/confirm/${id}`;
	},

	uriPsychologistsConfirmAccount(id = "") {
		return `${API_URL}/psychologists/confirm/${id}`;
	},

	uriLogs() {
		return `${API_URL}/statistics/logs`;
	},

	uriLogout() {
		return `${API_URL}/auth/logout`;
	},

	uriStaff(id = "") {
		return `${API_URL}/staff/${id}`;
	},

	uriUsersRecoverPassword(id = "") {
		return `${API_URL}/users/recover-password/${id}`;
	},

	uriUsersExpiredPassword() {
		return `${API_URL}/users/expired-password`;
	},

	uriPsychologistsRecoverPassword(id = "") {
		return `${API_URL}/psychologists/recover-password/${id}`;
	},

	uriStaffPassword() {
		return `${API_URL}/staff/password`;
	},

	uriStaffEmail() {
		return `${API_URL}/staff/email`;
	},

	uriImages() {
		return `${API_URL}/images`;
	},

	uriPages(id = "") {
		return `${API_URL}/pages/${id}`;
	},

	uriEmails(id = "") {
		return `${API_URL}/emails/${id}`;
	},

	uriUsers(id = "") {
		return `${API_URL}/users/${id}`;
	},

	uriSlots() {
		return `${API_URL}/psychologists/search-slots`;
	},

	uriAppointments(id = "") {
		return `${API_URL}/consultations/${id}`;
	},

    uriCancelAppointment(id = "") {
		return `${API_URL}/consultations/${id}/cancel`;
	},

	uriPsychologistsAppointments() {
		return `${API_URL}/psychologists/consultations`;
	},

	uriUsersAppointments() {
		return `${API_URL}/users/consultations`;
	},

	uriUsersLastAppointments(startDate: string, endDate: string) {
		return `${API_URL}/users/past-consultations/${startDate}/${endDate}`;
	},

	uriPsychologistsLastAppointments(startDate: string, endDate: string) {
		return `${API_URL}/psychologists/past-consultations/${startDate}/${endDate}`;
	},

	uriCalendar(startDate: string, endDate: string, psychologist: string = "") {
		return `${API_URL}/psychologists/calendar/${startDate}/${endDate}/${psychologist}`;
	},

	uriChangeEmail(id = "") {
		return `${API_URL}/users/change-email/${id}`;
	},

	uriBusinessUsers(id = "") {
		return `${API_URL}/businesses/users/${id}`;
	},

    uriBusinessResentInvitation(id = "") {
		return `${API_URL}/businesses/email/resendinvitation`;
	},

	uriImportUsers() {
		return `${API_URL}/businesses/import`;
	},

	uriDashboard() {
		return `${API_URL}/statistics/business`;
	},

	uriDashboardReport() {
		return `${API_URL}/statistics/business/report`;
	},

	uriPatients(id = "", idTreatment = "") {
		if (idTreatment) {
			return `${API_URL}/psychologists/patients/${id}/${idTreatment}`;
		}

		return `${API_URL}/psychologists/patients/${id}`;
	},

	uriProfile(id = "") {
		return `${API_URL}/psychologists/${id}`;
	},

	uriSkills() {
		return `${API_URL}/diagnostics`;
	},

	uriLanguages(id = "") {
		return `${API_URL}/languages/${id}`;
	},

	uriVideoCalls(id = "") {
		return `${API_URL}/video-calls/${id}`;
	},

	uriAudioCalls(id = "") {
		return `${API_URL}/voice-calls/${id}`;
	},

	uriSupport() {
		return `${API_URL}/users/support`;
	},

	uriChats(id = "") {
		return `${API_URL}/chats/${id}`;
	},

	uriChatMessage(id = "", messageId = "") {
		return `${API_URL}/chats/${id}/message/${messageId}`;
	},

	uriNotificationToken(id = "") {
		return `${API_URL}/auth/notif-token`;
	},

	uriReviews(id = "") {
		return `${API_URL}/users/review/treatment/${id}`;
	},

	uriEventsActive() {
		return `${API_URL}/events/active`;
	}
};
